class HttpCache {
  private _entries = new Map<string, any>();

  add(key: string, value: any) {
    if (this._entries.has(key)) {
      this._entries.delete(key);
    }
    this._entries.set(key, value);
  }

  get<T>(key: string) {
    if (this._entries.has(key)) {
      return this._entries.get(key) as T;
    }
    return null;
  }
}

const cache = new HttpCache();

export { cache as HttpCache };